import { FC } from 'react'

export const Copy: FC = () => (
  <svg
    width="1em"
    viewBox="-5 -5 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.46501 20.535C6.44285 20.535 4.61979 19.3169 3.84582 17.4487C3.07184 15.5805 3.49935 13.4301 4.92901 12L7.05101 9.87799L8.46501 11.292L6.34401 13.413C5.58607 14.1709 5.29007 15.2756 5.56749 16.311C5.84492 17.3464 6.65363 18.1551 7.68899 18.4325C8.72435 18.7099 9.82907 18.4139 10.587 17.656L12.708 15.535L14.122 16.95L12.001 19.071C11.0651 20.0115 9.79187 20.5387 8.46501 20.535ZM9.17201 16.242L7.75801 14.828L14.829 7.75699L16.243 9.17099L9.17301 16.241L9.17201 16.242ZM16.951 14.121L15.536 12.707L17.657 10.586C18.4253 9.83032 18.7292 8.72065 18.4533 7.67897C18.1773 6.63729 17.3638 5.82364 16.3222 5.54743C15.2806 5.27123 14.1709 5.57491 13.415 6.34299L11.293 8.46399L9.87901 7.04999L12.001 4.92799C13.9561 2.98996 17.11 2.99686 19.0566 4.94344C21.0031 6.89002 21.01 10.0439 19.072 11.999L16.951 14.12V14.121Z"
      fill="currentColor"
    />
  </svg>
)
